module.exports = __webpack_public_path__ + "img/znsj-2-sm.c0b1bb86.jpg";